import React,{useState} from 'react';
import TextField from '@material-ui/core/TextField';
import Axios from 'axios';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    underline: {
      "&&&:before": {
        borderBottom: "none"
      },
      "&&:after": {
        borderBottom: "none"
      }
    }
  });
  
function Chatbox(props) {
    const classes = useStyles();
    const [inputVal,setInput]=useState("");
    const dataUrl="https://warm-oasis-92826.herokuapp.com/chat";


    const sendResponse =(data) => {
        addtoDiv(data);
        Axios({
            method: 'post',
            url: dataUrl,
            data: {
              query: data,
            }
          }).then((response) => {
            if(response.status==200){
                addtoDiv(response.data,1);
            }
            
          }, (error) => {
          });
    } 
    
    
    const addtoDiv= (mydata,type) => {

        if(inputVal==""){
            return;
        }
        

        var element = document.createElement("div");
        
        element.style.borderRadius="8px";
        element.style.padding=".5rem";
        element.style.fontFamily="Montserrat";
        element.style.marginTop=".8rem";
        if(!type){
            element.style.color="black";
            element.style.backgroundColor="white";
            element.style.border=".2px solid black";
        }else{
            element.style.color="white";
            element.style.backgroundColor="blue";
        }
        
        
        element.appendChild(document.createTextNode(mydata));
        document.getElementById('chat-window').appendChild(element);

        setInput("");

    }


    return (
        <div>
            <div style={{position:"fixed",right:"1rem",height:"80vh",bottom:"0px",backgroundColor:"#ebecec",width: props.small ?"85%": "25%",zIndex:"101",border:"1px solid black"}}>
            <div style={{backgroundColor:"#e63946",width:"100%"}}> 
            <div style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
              <h1 style={{padding:".8rem",fontSize: ".8rem",
                fontFamily: "Montserrat",
                fontWeight: "bold",
                color: "white",}}>Chat</h1>
                <h1 style={{padding:".8rem",paddingRight:".8rem",fontSize: ".8rem",
                fontFamily: "Montserrat",
                fontWeight: "bold",
                color: "white", cursor:"pointer"}} onClick={()=>props.showChatBox()}>X</h1>
            </div>
            </div>

            <div style={{margin:"1rem",overflow:"auto",height:"75%"}} id="chat-window">
                <div style={{backgroundColor:"blue",padding:".5rem",borderRadius:"8px",color:"white",fontFamily:"Montserrat"}}>
                   Welcome to RD Foods, how may I help you?
                </div>

            </div>

            <div style={{position:"absolute",width:"100%",bottom:"0px",backgroundColor:"white",borderTop:".5px solid #e63946"}}>
            <div style={{backgroundColor:"#f5b461",width:"100%"}}> 
            <div style={{display:"flex",width:"100%"}}>
            <div style={{padding:".5rem",alignSelf:"stretch",backgroundColor:"#fff1e6",  width:"100%"}}>

            <TextField id="msg"  inputProps={{classes,disableUnderline: true, style: { fontFamily: 'nunito', color: '#606060'}}} placeholder="Type your message here.." value={inputVal} onChange={e => setInput(e.target.value)}/>


            </div>
            <div style={{padding:".8rem",backgroundColor:"#e63946",flex:"1",cursor:"pointer"}} onClick={()=>sendResponse(inputVal)}>
            <h1 style={{paddingLeft:".5rem",paddingTop:".2rem",paddingRight:".5rem",fontSize: ".8rem",
                fontFamily: "Montserrat",
                fontWeight: "bold",
                color: "white", }}  >Send</h1>
            </div>

            </div>
            </div>
            </div>            
        </div>
        </div>
    );
}

export default Chatbox;